import "./DashboardViewComponent.scss";
import template from "./DashboardViewComponent.html";
import {IComponentOptions} from "angular";
import {Ng1Controller, Transition} from "@uirouter/angularjs";
import {Observable} from "rxjs";
import {BreakpointObserver} from "../../../services/breakpoints/BreakpointObserver";
import {Breakpoint} from "../../../services/breakpoints/Breakpoint";
import {OpenTraderConversionEventService} from "../../../services/open-trader/google/OpenTraderConversionEventService";

export const DashboardView = "tfDashboardView";

export function dashboardView(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: DashboardViewComponentController
    };
}

interface StateParameters {
    readonly view?: number;
}

export class DashboardViewComponentController implements Ng1Controller {
    public activeView = 1;

    public readonly isMobile$: Observable<boolean>;

    /** @ngInject */
    public constructor(private readonly $stateParams: StateParameters,
                       private readonly breakpointObserver: BreakpointObserver,
                       private readonly openTraderConversionEventService: OpenTraderConversionEventService) {
        this.openTraderConversionEventService.sendUserIDView();
        this.activeView = this.$stateParams.view ?? 1;
        this.isMobile$ = this.buildIsMobile();
    }

    private buildIsMobile(): Observable<boolean> {
        return this.breakpointObserver
                   .observe(Breakpoint.Handset)
                   .map((bp) => bp.active)
                   .startWith(false)
                   .distinctUntilChanged()
                   .publishReplay(1)
                   .refCount();
    }

    /** @override */
    public $onInit() {
    }

    public uiOnParamsChanged(newValues: StateParameters, $transition$: Transition): void {
        if (newValues.view != null) {
            this.activeView = newValues.view;
        }
    }

    public uiCanExit(): boolean {
        return true;
    }
}
